import { ActivityBuilderDrawerLoading } from 'approot/activity-builder/activity-builder-drawer';
import { useGetStimulusResource } from 'approot/shared/stimulus/stimulus.hooks';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import type { GetStimulusResourceQuery } from '../../../shared/stimulus/stimulus.graphql.generated';
import { EditProps } from './video.constants';
import VideoEditPreview from './video-edit-preview';
import { VIDEO } from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

const VideoEditDrawer = ({
  id,
  properties,
  type,
  sectionId,
  lessonId,
}: EditProps) => {
  const { closeDrawer } = useActivityBuilderContext();

  const { data, loading } = useGetStimulusResource(
    properties.stimulusId!,
    true
  );

  const stimulus = data?.getStimulusResource as Extract<
    Pluck<GetStimulusResourceQuery, 'getStimulusResource'>,
    { __typename: 'StimulusResourceVideo' }
  >;

  return loading ? (
    <ActivityBuilderDrawerLoading
      title={type === VIDEO ? 'Video' : 'Audio'}
      onClose={closeDrawer}
    />
  ) : (
    <VideoEditPreview
      componentId={id}
      stimulus={stimulus}
      sectionId={sectionId}
      lessonId={lessonId}
    />
  );
};

export default VideoEditDrawer;
